import { type HTMLAttributes, type TableHTMLAttributes, type TdHTMLAttributes, type ThHTMLAttributes } from "react";
import { cn } from "../../lib/cn";

type TableCellVariant = "default" | "leading" | "number" | "action";
type TableResponsiveMode = "scroll" | "stack";

const tableCellVariantClassNames: Record<TableCellVariant, string | undefined> = {
  default: undefined,
  leading: "ui-table-cell-channel",
  number: "ui-table-cell-number",
  action: "ui-table-cell-action"
};

export function Table({
  className,
  responsive = "scroll",
  ...props
}: TableHTMLAttributes<HTMLTableElement> & { responsive?: TableResponsiveMode }) {
  return (
    <div className={cn("ui-table-scroll", responsive === "stack" && "ui-table-scroll-stack")}>
      <table className={cn("ui-table", responsive === "stack" && "ui-table-stack", className)} {...props} />
    </div>
  );
}

export function TableHeader({ className, ...props }: HTMLAttributes<HTMLTableSectionElement>) {
  return <thead className={cn("ui-table-head", className)} {...props} />;
}

export function TableBody({ className, ...props }: HTMLAttributes<HTMLTableSectionElement>) {
  return <tbody className={cn("ui-table-body", className)} {...props} />;
}

export function TableRow({ className, ...props }: HTMLAttributes<HTMLTableRowElement>) {
  return <tr className={cn("ui-table-row", className)} {...props} />;
}

export function TableHead({ variant = "default", className, ...props }: ThHTMLAttributes<HTMLTableCellElement> & { variant?: TableCellVariant }) {
  return <th className={cn("ui-table-head-cell", tableCellVariantClassNames[variant], className)} {...props} />;
}

export function TableCell({ variant = "default", className, ...props }: TdHTMLAttributes<HTMLTableCellElement> & { variant?: TableCellVariant }) {
  return <td className={cn("ui-table-cell", tableCellVariantClassNames[variant], className)} {...props} />;
}
